import styled from "styled-components";
import fipayFonts from "../../theme";

export const CheckoutWrapper = styled.div`
  display: flex;
  height: 100vh;
  width: 43%;
  margin-right: auto;
  box-sizing: border-box;
  & > * {
    box-sizing: border-box;
  }
  .fipay_img {
    width: 5.625rem;
    height: 2.875rem;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
    height: 70vh;

    .fipay_img {
      margin-top: 1rem;
    }
  }
`;

export const CheckoutLeft = styled.div<{
  backgroundColor?: string;
  color?: string;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: auto;
  padding: 1rem 3rem 0 6.25rem;
  background: ${({ backgroundColor }) =>
    backgroundColor || fipayFonts.colors.neutral.cultured};
  color: ${({ color }) => color || fipayFonts.colors.BLACK};

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-right: 0;

    padding: 0 1rem;
    background: ${({ backgroundColor }) =>
      backgroundColor || fipayFonts.colors.neutral.cultured};
    color: ${({ color }) => color || fipayFonts.colors.BLACK};
  }
`;
export const CheckoutRight = styled.div`
  max-width: 474px;
`;
export const LabelValueWrapper = styled.div``;

export const SummaryWrapper = styled.div`
  max-width: 474px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;
export const SubTax = styled.div`
  border-bottom: 1px solid ${fipayFonts.colors.LIGHT_GREY};
  padding-top: 1rem;
`;
export const ProductInfo = styled.div<{ $noBorder?: boolean }>`
  margin: 10px 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-bottom: ${({ $noBorder }) =>
    $noBorder ? "" : `1px solid ${fipayFonts.colors.LIGHT_GREY}`};
`;
export const ProductInfo1 = styled.div<{ $noBorder?: boolean }>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-top: 1.6rem;
  padding-bottom: 0.2rem;
  border-bottom: ${({ $noBorder }) =>
    $noBorder ? "" : `1px solid ${fipayFonts.colors.LIGHT_GREY}`};
`;

export const ProductPrice = styled.span`
  font-family: GT Walsheim pro;
  font-weight: 700;
  margin-top: 3rem;
  @media (max-width: 768px) {
    margin-top: 2.7rem;
  }
`;
export const Name = styled.span<{ color?: string }>`
  font-family: GT Walsheim pro;
  font-weight: 500;
  font-size: 1.05rem;
  letter-spacing: 0.02em;
  color: ${({ color }) => color || fipayFonts.colors.BLACK};
  margin-top: 0.7rem;
`;
export const Quantity = styled.div<{ color?: string }>`
  font-family: GT Walsheim pro;
  font-weight: 400;
  color: ${({ color }) => color || fipayFonts.colors.DARK_GRAY};
  margin-bottom: 0.5rem;

  display: flex;
  position: relative;
  align-items: center;
  gap: 12px;
  @media (max-width: 768px) {
    gap: 6px;
    margin: 0;
    flex-direction: row;
  }
`;
export const QtyNum = styled.input<{
  color?: string;
  backgroundColor?: string;
}>`
  font-family: GT Walsheim pro;
  font-weight: 400;
  color: ${({ color }) => color || fipayFonts.colors.BLACK};
  background: ${({ backgroundColor }) =>
    backgroundColor || fipayFonts.colors.neutral.cultured};
  width: 30px;
  /* border: none; */
  padding: 8px;
  border-radius: 6px;
  border: 2px solid #e8eaed;

  @media (max-width: 768px) {
    width: 20px;
    padding: 5px;
    margin: 0;
    border-radius: 6px;
    border: 2px solid #e8eaed;
  }

  &:focus {
    outline: blue;
  }
`;

export const Label = styled.span<{ color?: string }>`
  margin-bottom: 1.5rem;
  color: ${({ color }) => color || fipayFonts.colors.BLACK};
`;
export const Value = styled.span`
  font-family: GT Walsheim pro;
  font-weight: 700;
`;
export const Value1 = styled.span`
  font-family: GT Walsheim pro;
  font-weight: 700;
  font-size: 1.4rem;
`;
export const ProductImageWrapper = styled.div`
  display: flex;
  gap: 1.25rem;
  padding-bottom: 1.5rem;
`;
export const NameQty = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
export const ProductImage = styled.img`
  height: 70px;
`;

export const Title = styled.h5.attrs({ children: "Product Summary" })`
  font-family: GT Walsheim pro;
  font-weight: 700;
  font-size: 1.125rem;
  padding-top: 3rem;
`;

export const Title1 = styled.h5`
  font-family: GT Walsheim pro;
  font-weight: 700;
  font-size: 1.125rem;
  padding-top: 3rem;
  color: #0e0e0e;
`;
